import React from 'react';

import NewCoursePage from './NewCoursePage';

const NewAccessibility = props => (
  <NewCoursePage
    {...props}
    videoLink="mPXRoVy5upU"
    header={'Accessibility and Disability'}>
    {/* <h4>Your role as an accessible vehicle driver</h4> */}
    <ol className="new-course__body__content__olist">
      <li>
        Be able to safely assist passengers using mobility devices in and
        out of an accessible vehicle and be able to properly secure
        passengers and their wheelchairs into an accessible vehicle for
        hire.
      </li>
      <li>
        Be able to provide accessible customer service including:
        <ul className="new-course__body__content__olist--ulist">
          <li>Assisting a passenger using various mobility devices</li>
          <li>
            Assisting a passenger using a wheelchair to navigate a ramp,
            curb and doorway
          </li>
          <li>
            Guiding and assisting a passenger with a visual disability
          </li>
          <li>
            Assisting passengers with non-mobility related disabilities
          </li>
        </ul>
      </li>
      <li>
        Have knowledge and awareness about accessibility, disability and
        the relevant legislation.{' '}
      </li>
      <li>
        Have the required tools when providing driving services including a
        charged phone with data, a phone car mount, a valid driving license
        and suitable footwear.
      </li>
    </ol>
    <hr />
    <h4>Definitions</h4>
    <h5>Accessibility</h5>
    <p className="new-course__body__content__para">
      Accessibility refers to the design of products, devices, services, or
      environments for people who experience disabilities. Ontario has laws
      to improve accessibility for people with disabilities, including the
      Accessibility for Ontarians with Disabilities Act (AODA), the Ontario
      Human Rights Code, and the Ontario Building Code.
    </p>
    <h5>Disability</h5>
    <p className="new-course__body__content__para">
      A disability is a physical or mental condition that limits a person’s
      movements, senses, or activities. The AODA uses the same definition
      of disability as the Ontario Human Rights Code.
    </p>
    <h5>AODA</h5>
    <p className="new-course__body__content__para">
      The Accessibility for Ontarians with Disabilities Act (AODA) seeks to
      ensure that all Ontarians have fair and equitable access to programs
      and services and to improve opportunities for persons with
      disabilities. The Act address barriers in Customer Service;
      Information and Communication; Employment; Transportation; the Design
      of Public Spaces
    </p>
    <h5>Barrier</h5>
    <p className="new-course__body__content__para">
      A barrier is a circumstance or obstacle that keeps people apart. For
      people with disabilities, barriers can take many forms including
      attitudinal, communication, physical, policy, programmatic, social,
      and transportation.
    </p>
    <br />
    <br />
  </NewCoursePage>
);

export default NewAccessibility;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewAccessibility.js